import * as React from 'react';
import { PVAContentHeader, PVAContentBody } from '../';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { PonderaEditor } from '../common/PonderaEditor';
import { BaseRouteProps } from '../../interfaces';
import { UserStore, FilterStore } from '../../stores';
import { Button } from 'react-bootstrap';
import { SiteSettingsService } from '../../services';
import { SiteSettings } from '../../models/SiteSettings';
import { PonderaModal } from '../inclinationmodals';

interface State {
    settings: SiteSettings | undefined;
    showNewUserKeys: boolean;
    showResetPassKeys: boolean;
}

interface Props extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class SiteSettingsComponent extends React.Component<Props, State> {
    siteSettingsService: SiteSettingsService = new SiteSettingsService(this.props.notificationService);

    constructor(props: Props) {
        super(props);

        this.state = {
            settings: undefined,
            showNewUserKeys: false,
            showResetPassKeys: false,
        };
    }

    componentDidMount() {
        // get site settings
        this.siteSettingsService.get().then((settings: SiteSettings) => {
            this.setState({
                settings
            });
        });
    }

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get userPermissions() {
        return this.props.UserStore!.userInfo.userPermissions;
    }

    save = () => {
        const { settings } = this.state;

        if (!settings) {
            return;
        }

        this.siteSettingsService.update(settings).then((siteSettings: SiteSettings) => {
            this.setState({
                settings: siteSettings
            });
        });
    }

    updateResetPassword = (content: string) => {
        const { settings } = this.state;
        if (!settings) {
            return;
        }

        settings.resetPasswordEmail = content;
        this.setState({
            settings
        });
    }

    updateNewUser = (content: string) => {
        const { settings } = this.state;
        if (!settings) {
            return;
        }

        settings.newUserEmail = content;
        this.setState({
            settings
        });
    }

    showNewUserKeysModal = () => {
        this.setState({
            showNewUserKeys: true
        });
    }
    hideNewUserKeysModal = () => {
        this.setState({
            showNewUserKeys: false
        });
    }
    showResetPassKeysModal = () => {
        this.setState({
            showResetPassKeys: true
        });
    }
    hideResetPassKeysModal = () => {
        this.setState({
            showResetPassKeys: false
        });
    }

    public render() {

        const { settings } = this.state;

        if (!settings) {
            return <div />;
        }

        return (
            <div>
                <PVAContentHeader>
                    <div className="row">
                        <div className="col-xs-9">
                            <div className="title">
                                Site Settings
                            </div>
                        </div>
                        <div className="col-xs-3 text-right">
                            <Button onClick={this.save} >Save</Button>
                        </div>
                    </div>
                </PVAContentHeader>

                <PVAContentBody>

                    <div className="row">
                        <div className="col-xs-9">
                            <h3>Default New User Email</h3>
                        </div>
                        <div className="col-xs-3 text-right">
                            <Button onClick={this.showNewUserKeysModal} >Keys</Button>
                        </div>
                    </div>
                    <PonderaEditor content={settings.newUserEmail} onSave={this.updateNewUser} />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-xs-9">
                            <h3>Default Reset Password Email</h3>
                        </div>
                        <div className="col-xs-3 text-right">
                            <Button onClick={this.showResetPassKeysModal} >Keys</Button>
                        </div>
                    </div>
                    <PonderaEditor content={settings.resetPasswordEmail} onSave={this.updateResetPassword} />

                    <PonderaModal 
                        simpleTitle={true}
                        title="New User Email - Keys"
                        show={this.state.showNewUserKeys} 
                        content="" 
                        complexContent={(
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <td>Key</td>
                                        <td>Description</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>#{'{'}FIRSTNAME{'}'}</td>
                                        <td>The first name of the user.</td>
                                    </tr>
                                    <tr>
                                        <td>#{'{'}LASTNAME{'}'}</td>
                                        <td>The last name of the user.</td>
                                    </tr>
                                    <tr>
                                        <td>#{'{'}ORGANIZATION{'}'}</td>
                                        <td>The name of the organization the user is in.</td>
                                    </tr>
                                    <tr>
                                        <td>#{'{'}RESETPASSWORDLINK{'}'}</td>
                                        <td>The link to set a users password.</td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                        onHide={this.hideNewUserKeysModal}
                    />
                    
                    <PonderaModal 
                        simpleTitle={true}
                        title="Password Reset Email - Keys"
                        show={this.state.showResetPassKeys} 
                        content="" 
                        complexContent={(
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <td>Key</td>
                                        <td>Description</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>#{'{'}FIRSTNAME{'}'}</td>
                                        <td>The first name of the user.</td>
                                    </tr>
                                    <tr>
                                        <td>#{'{'}LASTNAME{'}'}</td>
                                        <td>The last name of the user.</td>
                                    </tr>
                                    <tr>
                                        <td>#{'{'}ORGANIZATION{'}'}</td>
                                        <td>The name of the organization the user is in.</td>
                                    </tr>
                                    <tr>
                                        <td>#{'{'}RESETPASSWORDLINK{'}'}</td>
                                        <td>The link to set a users password.</td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                        onHide={this.hideResetPassKeysModal}
                    />
                    
                </PVAContentBody>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/siteSettings/SiteSettings.tsx